var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userName)?_c('div',{staticClass:"userBadge"},[_c('span',[_vm._v(" "+_vm._s(_vm.userName)+" ")]),_c('img',{attrs:{"src":_vm.userPicture}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }